import axios from '../../utils/axios'
import store from '../store'
import { getFormattedDate } from '../../utils/helpers'

export const SET_SCAN_PACKAGE_LOADER = 'SET_SCAN_PACKAGE_LOADER'
export const GET_SCAN_PACKAGE_DETAILS = 'GET_SCAN_PACKAGE_DETAILS'
export const GET_SCAN_PACKAGE_ERROR = 'GET_SCAN_PACKAGE_ERROR'
export const POST_SCAN_PACKAGE_SUCCESS = 'POST_SCAN_PACKAGE'
export const POST_SCAN_PACKAGE_ERROR = 'POST_SCAN_PACKAGE_ERROR'

export const GetScanPackageDetails = id => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'get',
    baseURL: config.baseURL,
    url: `/package/${id}`,
    headers: {
      'Content-Type': 'application/json'
    }
  }

  return async dispatch => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then(response => {
        if (response.data?.FulfillmentPackage === null) {
          dispatch(GetScanPackageError('Package Details not found'))
        }
        if (response.data?.FulfillmentPackage !== null) {
          response.data.FulfillmentPackage.ApplicationDate = getFormattedDate(response.data.FulfillmentPackage.ApplicationDate)
          response.data.FulfillmentPackage.Printed = getFormattedDate(response.data.FulfillmentPackage.Printed)
          let shippedString = ''
          if (response.data.FulfillmentPackage.CancelledBy !== '') {
            shippedString = getFormattedDate(response.data.FulfillmentPackage.CancelledDate)
          } else if (response.data.FulfillmentPackage.ScannedBy !== '') {
            shippedString = getFormattedDate(response.data.FulfillmentPackage.ScannedDate)
          }
          response.data.FulfillmentPackage.ShippedString = shippedString
        }
        dispatch(GetScanPackage(response.data))
      })
      .catch(error => {
        console.log(
          `GetScanPackageDetails error is: ${
            error?.response?.data?.Message
              ? error?.response?.data?.Message
              : error.message
          }`
        )
        dispatch(
          GetScanPackageError(
            error?.response?.data?.Message
              ? error?.response?.data?.Message
              : error.message
          )
        )
      })
      .finally(() => {
        dispatch(SetLoading(false))
      })
  }
}

export const PostScanPackage = id => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/stuff',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      PackageId: id
    }
  }

  return async dispatch => {
    return axios(axiosConfig)
      .then(() => {
        dispatch(PostScanPackageSuccess(true))
      })
      .catch(error => {
        console.log(
          `PostScanPackage error is: ${
            error?.response?.data?.Message
              ? error?.response?.data?.Message
              : error.message
          }`
        )
        dispatch(
          PostScanPackageError(
            error?.response?.data?.Message
              ? error?.response?.data?.Message
              : error.message
          )
        )
      })
      .finally(() => {
        dispatch(PostScanPackageSuccess(false))
        dispatch(SetLoading(false))
      })
  }
}

export const SetLoading = isLoading => {
  return {
    type: SET_SCAN_PACKAGE_LOADER,
    loading: isLoading
  }
}

export const GetScanPackage = (packageDetails = {}) => {
  return {
    type: GET_SCAN_PACKAGE_DETAILS,
    packageDetails
  }
}

export const GetScanPackageError = error => {
  return {
    type: GET_SCAN_PACKAGE_ERROR,
    error
  }
}

export const PostScanPackageSuccess = (isSuccess) => {
  return {
    type: POST_SCAN_PACKAGE_SUCCESS,
    packageSuccess: isSuccess
  }
}

export const PostScanPackageError = error => {
  return {
    type: POST_SCAN_PACKAGE_ERROR,
    error
  }
}
